/*
 *   File : fund.js
 *   Author : https://evoqins.com
 *   Description : Fund explore card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useLocation, useNavigate } from "react-router-dom";

import { useState, useEffect } from "react";
// Component
import Chip from "../Other/chip";

//styles
import styles from "../../Style/Component/card.module.scss";
import Colors from "../../Style/color.scss"

//assets
import RightIcon from "../../Assets/Images/right-black-icon.svg";
import { Icon } from "../Icon";

const FundCard = (props) => {

    const { data, tenureData } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [type, setType] = useState(1);

    useEffect(() => {
        setType(props.tabIndex)
    }, [props.tabIndex])

    const _handleOnClick = (id) => {
        let path = location.pathname === "/explore" ? "fund-details" : "/explore/fund-details";
        navigate(path, {
            state: {
                fund_id: id,
            }
        })
    };

    return (
        props.type == 4 ?
            <div className={`e-border-1px-lavender-blue-light cursor-pointer p-2 p-sm-3 e-bg-alice-blue e-border-radius-20 h-100 card-hover `}
                onClick={() => props.handleOnClick(props.data)}>
                <div className={`d-flex gap-2 gap-sm-3  align-items-center e-border-bottom-1px-lavender-blue-light pb-2 pb-sm-3`}>
                    <div className="e-bg-white e-border-radius-6 align-self-start">
                        <img src={data.image}
                            className="p-1 object-fit-contain e-border-radius-6 h-40 w-40px width-24px-res object-fit-contain"
                            draggable="false"
                            alt="fund" />
                    </div>
                    <div className="d-flex flex-column gap-1">
                        <h3 className="e-ellipse-single mb-0 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-20px">
                            {data.scheme_name}
                        </h3>
                        <div className="d-flex align-items-center gap-2 e-text-charleston-green text-nowrap e-font-12 e-alt-font-poppins e-font-weight-400 line-height-20px">
                            {data.option_name}
                            <Icon
                                icon="bullet"
                                color={"#93B5E9"}
                                size={"0.25rem"}
                            />
                            {data.asset_category}
                        </div>
                    </div>
                    <div className="ms-auto">
                        <Icon
                            icon="arrow-down"
                            color={Colors.egyptian_blue}
                            className="transform-rotate-min-90 w-16px width-12px-res"
                        />
                    </div>
                </div>
                <div className="e-display-flex justify-content-between mt-2 mt-sm-3">
                    <div>
                        <p className="mb-1 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                            Last {data.returns.tenure_text}
                        </p>
                        <p className="mb-0 e-text-charleston-green  e-font-12-res e-font-14 e-primary-font-inter e-font-weight-600 line-height-16px">
                            {data.returns.returns_percentage_text}
                        </p>
                    </div>
                    <div>
                        <p className="mb-1 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                            Min invest
                        </p>
                        <p className="mb-0 e-text-charleston-green e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-600 line-height-20px">
                            ₹{data.min_investment?.sip ? data.min_investment.sip.toLocaleString() : 0}
                        </p>
                    </div>
                    <div>
                        <p className="mb-1 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                            Fund size
                        </p>
                        <p className="mb-0 e-text-charleston-green e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-600 line-height-20px">
                            ₹{data.fund_size}
                        </p>
                    </div>
                </div>
            </div>
            :
            props.type == 3 ?
                <div className={`e-border-1px-lavender-blue-light cursor-pointer padding-12px-all e-bg-alice-blue e-border-radius-16 h-100`}>
                    <div className={`d-flex gap-2 gap-sm-3  align-items-center e-border-bottom-1px-lavender-blue-light pb-2`}>
                        <img
                            src={props.data.image}
                            className="object-fit-contain e-border-radius-6 e-bg-white p-1 w-40px width-32px-res object-fit-contain align-self-start"
                            draggable="false"
                            alt="fund" />
                        <div className="d-flex flex-column gap-1">
                            <h3 className="e-ellipse mb-0 e-text-charleston-green e-font-14-res e-font-14    e-alt-font-poppins e-font-weight-500 line-height-14px">
                                {props.data.name}
                            </h3>
                            <div className="d-flex align-items-center gap-2 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-400 line-height-20px">
                                {props.data.scheme_category}
                                <Icon
                                    icon="bullet"
                                    color={"#93B5E9"}
                                    size={"0.25rem"}
                                />
                                {props.data.option_name}
                            </div>
                        </div>
                    </div>
                    <div className="e-display-flex justify-content-between padding-12px-top">
                        <div>
                            <p className="mb-1 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                                Last {tenureData?.returns.tenure_text}
                            </p>
                            <p className="mb-0 e-text-charleston-green  e-font-12-res e-font-14 e-primary-font-inter e-font-weight-600 line-height-16px">
                                {tenureData?.returns.returns_percentage_text}
                            </p>
                        </div>
                        <div>
                            <p className="mb-1 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                                Min invest
                            </p>
                            <p className="mb-0 e-text-charleston-green e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                {
                                    type === 1 && props.data.min_investment.sip ?
                                        `₹${props.data.min_investment.sip}`
                                        :
                                        type === 2 && props.data.min_investment.lumpsum ?
                                            `₹${props.data.min_investment.lumpsum}`
                                            :
                                            '-'
                                }

                            </p>
                        </div>
                        <div>
                            <p className="mb-1 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                                Fund size
                            </p>
                            <p className="mb-0 e-text-charleston-green e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                ₹ {tenureData?.fund_size}
                            </p>
                        </div>
                    </div>
                </div>
                :
                props.type == 2 ?
                    <div className={`e-border-1px-lavender-blue-light cursor-pointer p-2 p-sm-3 e-bg-alice-blue e-border-radius-16 h-100`}
                        onClick={() => props.handleInvest(props.data)}>
                        <div className={`d-flex gap-2 gap-sm-3  align-items-center e-border-bottom-1px-lavender-blue-light pb-2 pb-sm-3`}>
                            <div className="e-bg-white p-1 p-sm-2 e-border-radius-6 align-self-start">
                                <img src={data.image}
                                    className="object-fit-contain e-border-radius-6 w-40px width-24px-res object-fit-contain"
                                    draggable="false"
                                    alt="fund" />
                            </div>
                            <div className="d-flex flex-column gap-1">
                                <h3 className="e-ellipse mb-md-1 mb-sm-2 mb-1 e-text-charleston-green e-font-14-res-lg e-font-16 e-alt-font-poppins e-font-weight-500 line-height-20px">
                                    {data.scheme_name}
                                </h3>
                                <div className="d-flex align-items-center gap-2 e-text-charleston-green e-font-12-res e-font-14-res-lg text-nowrap e-font-16 e-alt-font-poppins e-font-weight-400 line-height-20px">
                                    {data.option_name}
                                    <Icon
                                        icon="bullet"
                                        color={"#93B5E9"}
                                        size={"0.25rem"}
                                    />
                                    {data.asset_category}
                                </div>
                            </div>
                            <div className="ms-auto">
                                <Icon
                                    icon="arrow-down"
                                    color={Colors.egyptian_blue}
                                    className="transform-rotate-min-90 w-16px width-12px-res"
                                />
                            </div>
                        </div>
                        <div className="e-display-flex justify-content-between mt-2 mt-sm-3">
                            <div>
                                <p className="mb-1 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                                    Last {data.returns.tenure_text}
                                </p>
                                <p className="mb-0 e-text-charleston-green  e-font-12-res e-font-14 e-primary-font-inter e-font-weight-600 line-height-16px">
                                    {data.returns.returns_percentage_text}
                                </p>
                            </div>
                            <div>
                                <p className="mb-1 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                                    Min invest
                                </p>
                                <p className="mb-0 e-text-charleston-green e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                    ₹{data.min_investment?.sip ? data.min_investment.sip.toLocaleString() : 0}
                                </p>
                            </div>
                            <div>
                                <p className="mb-1 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                                    Fund size
                                </p>
                                <p className="mb-0 e-text-charleston-green e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                    ₹{data.fund_size}
                                </p>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={`${styles.e_fund_card_wrapper} transition cursor-pointer e-bg-anti-flash-white-light e-border-radius-16 h-100`}
                        onClick={() => { _handleOnClick(props.data.mf_id) }}>
                        <div className={`${styles.e_fund_card} d-flex gap-3 p-3`}>
                            <div className="">
                                <img src={props.data.image}
                                    width={48}
                                    height={48}
                                    className="object-fit-contain e-border-radius-10 e-bg-white p-1"
                                    draggable="false"
                                    alt="fund" />
                            </div>
                            <div className="">
                                <div className="d-flex justify-content-space-between">
                                    <h3 className="e-ellipse mb-md-1 mb-sm-2 mb-1 e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                        {props.data.scheme_name}
                                    </h3>
                                    <div>
                                        <img src={RightIcon}
                                            draggable="false"
                                            className={`${styles.e_right_arrow} transition`}
                                            alt="arrow" />
                                    </div>
                                </div>

                                <div className="d-flex flex-wrap gap-2 mt-1">
                                    <Chip className={"py-1 px-3 e-font-10 line-height-14px"}
                                        name={props.data.asset_category} />

                                    {
                                        props.data.option_name !== null &&
                                        <Chip className={"py-1 px-3 e-font-10 line-height-14px"}
                                            name={props.data.option_name} />
                                    }
                                </div>
                            </div>
                        </div>
                        {/* calculated */}
                        <div className={styles.e_border_bottom}></div>
                        <div className="e-display-flex justify-content-between p-3">
                            <div>
                                <p className="mb-1 e-text-onyx e-font-14 e-alt-font-poppins e-font-weight-400 line-height-20px">
                                    AUM
                                </p>
                                <p className="mb-0 e-text-charleston-green e-font-14 e-primary-font-inter e-font-weight-600 line-height-20px">
                                    {props.data.fund_size}
                                </p>
                            </div>
                            <div>
                                <p className="mb-1 e-text-onyx e-font-14 e-alt-font-poppins e-font-weight-400 line-height-20px">
                                    CAGR
                                </p>
                                <p className="mb-0 e-text-ufo-green e-font-14 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                    {props.data.returns.returns_percentage} <span className="e-text-charleston-green e-font-12 e-font-weight-400 ">({props.data.returns.tenure_text})</span>
                                </p>
                            </div>
                            {
                                props.data.risk !== null &&
                                <img src={props.data.risk_icon}
                                    draggable="false"
                                    width={70}
                                    height={48}
                                    className="object-fit-contain"
                                    alt="risk-calculator" />
                            }
                        </div>
                    </div>
    )
}
export default FundCard;

FundCard.defaultProps = {
    handleInvest: () => { }
}